
import messages from '../translations';

let idiomas = new Object();

for(let lang in messages){
	// Este condicional para que solo tengamos disponibles ES y EN
	if (lang == 'es' || lang == 'en') {
		idiomas[lang] = messages[lang].enlaces;
	}
}

let langSelected = "es";

export function langdetector() {

	let path = location.pathname;

	if(path == "/" || path == "/404"){
		//let disponibles = ['ja','es','en','ru'];
		let disponibles = ["es", "en"];
		let navLang = navigator.language.substring(0,2);
		langSelected = (disponibles.some(e => e == navLang)) ? navLang : 'es';
	}else{

		path = '/'+path.split("/")[1];

		for(let lang in idiomas){

			let array = Object.entries(idiomas[lang]);
			
			(array.some(e => e[1] == path)) ? langSelected = lang : '';

		}

	}

	return langSelected;

}


// WEBPACK FOOTER //
// ./src/langdetector/index.js